var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { PureComponent, createElement } from 'react';
import { Modal as AntModal } from 'antd';
import { ComponentsManager } from '@comall-backend-builder/core';
import { extendsParentProps } from '../component-props';
import PropTypes from 'prop-types';

var MessageModal = function (_super) {
  __extends(MessageModal, _super);

  function MessageModal(props) {
    var _this = _super.call(this, props) || this;

    _this.handleOkClick = _this.handleOkClick.bind(_this);
    _this.handleCancelClick = _this.handleCancelClick.bind(_this);
    _this.handleTriggerClick = _this.handleTriggerClick.bind(_this);
    return _this;
  }
  /**
   * 通过点击事件来触发弹层
   */


  MessageModal.prototype.handleTriggerClick = function () {
    var _a = this.props,
        title = _a.title,
        mode = _a.mode,
        icon = _a.icon,
        okText = _a.okText,
        okType = _a.okType,
        cancelText = _a.cancelText,
        maskClosable = _a.maskClosable,
        width = _a.width,
        className = _a.className,
        content = _a.content,
        zIndex = _a.zIndex;
    var props = {
      title: title,
      icon: icon,
      okText: okText,
      okType: okType,
      cancelText: cancelText,
      maskClosable: maskClosable,
      width: width,
      content: content,
      className: className,
      zIndex: zIndex,
      onOk: this.handleOkClick,
      onCancel: this.handleCancelClick
    };

    switch (mode) {
      case 'confirm':
        this.modalRef = AntModal.confirm(props);
        break;

      case 'info':
        this.modalRef = AntModal.info(props);
        break;

      case 'success':
        this.modalRef = AntModal.success(props);
        break;

      case 'error':
        this.modalRef = AntModal.error(props);
        break;

      case 'warning':
        this.modalRef = AntModal.warning(props);
        break;

      default:
        this.modalRef = AntModal.info(props);
    }
  };
  /**
   * 确认按钮的点击事件
   */


  MessageModal.prototype.handleOkClick = function () {
    var onConfirm = this.props.onConfirm;

    if (onConfirm) {
      onConfirm();
    }

    this.modalRef.destroy();
  };
  /**
   * 取消按钮的点击事件
   */


  MessageModal.prototype.handleCancelClick = function () {
    var onCancel = this.props.onCancel;

    if (onCancel) {
      onCancel();
    }

    this.modalRef.destroy();
  };

  MessageModal.prototype.render = function () {
    var triggerComponent = this.renderTrigger();
    return React.createElement("div", null, triggerComponent);
  };
  /**
   * 渲染响应触发弹层事件的组件
   */


  MessageModal.prototype.renderTrigger = function () {
    var _a = this.props.triggerComponent,
        component = _a.component,
        otherProps = __rest(_a, ["component"]);

    Object.assign(otherProps, {
      onClick: this.handleTriggerClick
    });
    var props = extendsParentProps(__assign({}, otherProps), this.props);
    return createElement(ComponentsManager.get(component), props);
  };

  MessageModal.defaultProps = {
    maskClosable: true
  };
  MessageModal.propTypes = {
    // 确认按钮处理的函数
    onConfirm: PropTypes.func,
    // 取消按钮处理的函数
    onCancel: PropTypes.func,
    // 弹层的标题
    title: PropTypes.string,
    // 弹层的模式
    mode: PropTypes.oneOf(['confirm', 'info', 'success', 'error', 'warning']),
    // 用来触发弹层的组件
    triggerComponent: PropTypes.object,
    // 弹层内显示的内容
    content: PropTypes.string,
    // 自定义确认按钮的显示文字内容
    okText: PropTypes.string,
    // 自定义取消按钮的显示文字内容
    cancelText: PropTypes.string,
    // 图标 Icon 类型
    iconType: PropTypes.string,
    // 点击蒙层是否允许关闭
    maskClosable: PropTypes.bool,
    // 弹层窗体的宽度
    width: PropTypes.string,
    // Modal的z-index
    zIndex: PropTypes.number
  };
  return MessageModal;
}(PureComponent);

export { MessageModal };